import {createApp} from 'vue';
import ProductDetailGallery from '../../components/ProductDetailGallery.vue';
import i18n from '../../plugins/i18n';

const pfcDetailGallery = document.querySelector('#pfc-detail-gallery');
if (pfcDetailGallery !== null) {
    createApp(ProductDetailGallery, {
        title: pfcDetailGallery.getAttribute('data-title'),
        images: JSON.parse(window.atob(pfcDetailGallery.getAttribute('data-images'))),
        slidesToShow: pfcDetailGallery.getAttribute('data-slides-to-show'),
        showAr: !!pfcDetailGallery.hasAttribute('data-show-ar'),
        arConfig: pfcDetailGallery.getAttribute('data-ar-config'),
        configuratorUrl: pfcDetailGallery.getAttribute('data-configurator-url'),
        arMailCreatedType: pfcDetailGallery.getAttribute('data-ar-mail-created-type'),
    })
        .use(i18n)
        .mount(pfcDetailGallery);
}

